import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awsop-lab14',
  templateUrl: './awsop-lab14.component.html',
  styleUrls: ['./awsop-lab14.component.css']
})
export class AwsopLab14Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab14/awsop-lab14.component.ts